import type { PaymentSessionMode } from '@subscriptions/domain/types';
import { PaymentSessionModes } from '@subscriptions/domain/types';

import { isReactivationOrigin } from './wizardOrigin';

/**
 * Picks the Stripe session mode for the card branch.
 *
 * The reactivation origin wins over the license status. A churned block can still read as
 * `AVAILABLE`: the backend recalculates the license status without looking at the customer state,
 * so the two drift apart. Without this precedence such a block would be charged as if it were
 * merely changing its payment method, instead of the remainder of the cycle plus the
 * reactivation fee.
 */
export const resolveSessionMode = (isLicenseActive: boolean, search: string): PaymentSessionMode => {
  if (isReactivationOrigin(search)) return PaymentSessionModes.REACTIVATION;
  return isLicenseActive ? PaymentSessionModes.NEW_PAYMENT_METHOD_AND_CHARGE : PaymentSessionModes.PAY_SUBSCRIPTION;
};
